module.exports = __webpack_public_path__ + "static/media/gratitude-badge.90406e13.svg";